// extracted by mini-css-extract-plugin
export var standaloneTable = "_v-0";
export var standaloneTableWithBodyFill = "_v-1";
export var withExtraHeader = "_v-2";